import { Component } from '@angular/core';
import { IconBaseComponent } from '../icon-base.component';

@Component({
  selector: 'icon-fa-arrow-up-right',
  templateUrl: './icon-fa-arrow-up-right.component.html'
})
export class IconFaArrowUpRightComponent extends IconBaseComponent {
  constructor() {
    super();
  }
}
